.Pills {
  display: flex;
  flex-flow: row wrap;
  flex-grow: 1;
  gap: 8px;
}

.Pill {
  align-items: center;
  border: 1px solid var(--bs-border-color);
  border-radius: 15px;
  display: inline-flex;
  gap: 8px;
  padding: 2px 6px 2px 12px;
  background-color: var(--bs-gray-200);
}

.PillRemove {
  background: none;
  border: none;
  font-size: 0.75em;
  line-height: 1;
  padding: 0;
}
